import { LearnersSchoolsStudentList } from "@/types/serializers"
import { EditProps } from "../students/page-props"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  students: Array<LearnersSchoolsStudentList>
}

export const useIndexProps = () => useProps<IndexProps>()

export type NewProps = EditProps
